import { graphqlApi } from '@/graphql'
import { baseApi } from '@/services'
import { CreditReport } from '@/types/unlock'

export const creditReportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateCreditReport: builder.mutation<
      CreditReport,
      { applicationUuid: string; payload: Partial<CreditReport> }
    >({
      query: (arg) => ({
        method: 'PATCH',
        url: `v2/credit-reports/${arg.payload.external_id}/`,
        body: arg.payload,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationCalcs',
      ],
    }),
    deleteCreditReport: builder.mutation<
      CreditReport,
      { applicationUuid: string; creditReportExternal: number }
    >({
      query: (arg) => ({
        method: 'DELETE',
        url: `v2/credit-reports/${arg.creditReportExternal}/`,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'Tradeline',
        'Documents',
        'Alert',
      ],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(
          graphqlApi.util.invalidateTags([
            'gql:application',
            'gql:applicationCalcs',
            'gql:applicationTradelinesCalcs',
          ])
        )
      },
    }),
  }),
})

export const { useUpdateCreditReportMutation, useDeleteCreditReportMutation } = creditReportApi
